module.exports = __webpack_public_path__ + "static/housesAerial-199e1f32f086824c5324f81b363c8b77.jpg";